export function removeHTMLTags(text: string, allowedTags: string[] = []) {
  const allowedTagsSet = new Set(allowedTags.map((tag) => tag.toLowerCase()));
  const htmlTagsRegExp = /<\/?([a-z0-9]*)\b[^>]*>/gi;

  let previous: string;
  let result = text;

  // Repeat until stable: a single pass can leave a tag behind when tags are
  // nested, e.g. "<<script>script>" becomes "<script>".
  do {
    previous = result;
    result = previous.replace(htmlTagsRegExp, (tag, tagName: string) =>
      allowedTagsSet.has(tagName.toLowerCase()) ? tag : '',
    );
  } while (result !== previous);

  return result;
}
